import React from "react";
import CustomSelect from "../../../Common/CustomSelect";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import DatePicker from "../../../Common/DatePicker";
import styles from "./styles.module.css";

export const FilterValueSelector = ({
    selectedFieldValue,
    setSelectedFieldValue,
    fieldValues,
    setFilters,
    selectedDateField,
    dateTypeMetadata,
    filters,
}) => {
    return (
        <>
            {Boolean(fieldValues?.length) && (
                <CustomSelect
                    mode="multiple"
                    allowClear
                    showSearch
                    options={fieldValues}
                    style={{ width: 150 }}
                    placeholder="Select Filter Value"
                    value={selectedFieldValue}
                    valueKey="value"
                    labelKey="value"
                    size="small"
                    onChange={(value) => setSelectedFieldValue(value)}
                    maxTagCount="responsive"
                />
            )}
            {dateTypeMetadata.map((item) => {
                const filter = filters.find((el) => el.name === item.name);
                return (
                    <div key={item.name} className={styles.dateFilter}>
                        <label className={styles.filterName}>{item.name}</label>
                        <DatePicker
                            name={item.name}
                            filter={filter}
                            setFilters={setFilters}
                            selectedDateField={selectedDateField}
                        />
                    </div>
                );
            })}
        </>
    );
};
